import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import Logo from '@/components/generals/logo'
import { siteConfig } from '@/constants/site'

const FOOTER_COLUMNS = [
    {
        heading: 'Explore',
        links: [
            { label: 'Services', href: '/services' },
            { label: 'The book', href: '/book' },
            { label: 'Accounting games', href: '/games' }
        ]
    },
    {
        heading: 'Play',
        links: [
            { label: 'Word Scramble', href: '/games/word-scramble' },
            { label: 'Accounting Equation', href: '/games/accounting-equation' }
        ]
    },
    {
        heading: 'Talk to us',
        links: [
            { label: 'Contact', href: '/contact' }
        ]
    }
]

const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='border-t border-border bg-card'>
            <div className='mx-auto grid max-w-6xl gap-10 px-5 py-14 sm:px-8 md:grid-cols-[1.4fr_repeat(3,1fr)]'>
                <div className='max-w-xs'>
                    <Logo />

                    <p className='mt-4 text-sm leading-relaxed text-muted-foreground'>
                        {siteConfig.tagline}. Practical systems, sound controls and clear reports.
                    </p>
                </div>

                {FOOTER_COLUMNS.map(column => (
                    <div key={column.heading}>
                        <h2 className='text-xs font-semibold tracking-[0.14em] text-muted-foreground uppercase'>
                            {column.heading}
                        </h2>

                        <ul className='mt-4 space-y-3'>
                            {column.links.map(link => (
                                <li key={link.href}>
                                    <Link
                                        href={link.href}
                                        className='text-sm text-foreground/80 transition-colors hover:text-primary'
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>

            <div className='border-t border-border'>
                <div className='mx-auto flex max-w-6xl flex-col gap-2 px-5 py-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between sm:px-8'>
                    <p>
                        &copy; <span suppressHydrationWarning>{new Date().getFullYear()}</span> {siteConfig.name}. All rights reserved.
                    </p>

                    <p>
                        Assets = Liabilities + Equity
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default SiteFooter
